import { render, staticRenderFns } from "./tests.vue?vue&type=template&id=72340d38&scoped=true"
import script from "./tests.vue?vue&type=script&lang=js"
export * from "./tests.vue?vue&type=script&lang=js"
import style0 from "./tests.vue?vue&type=style&index=0&id=72340d38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72340d38",
  null
  
)

export default component.exports